/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, getProp, $Sprite, $GraphicsBox} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Button} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Button';
import {Circle} from 'pixi.js';
import {BetSelectProps, BetSelectActions, computedDisableMinus, computedDisablePlus} from './etc';
import {$PanelDisplay} from '../PanelDisplay';
import {uiMainScreenEmitter} from '../../UIMainScreenEmitter';
import {Store} from '@gongxigames/framework/core';
import {uiElementsStore} from '@gongxigames/framework/slotV2/ui/services/UIElementsStates/uiElementsStore';

const BUTTON_HIT_AREA = new Circle(0, 0, 50);

export const $BetSelectPortrait: FC<BetSelectProps> = (props) => {
    const disablePlus = computedDisablePlus(props);
    const disableMinus = computedDisableMinus(props);
    const interactive = Store.computed(() => !uiElementsStore.bet_panel_disabled.value);
    const betPanelHidden = Store.computed(() => uiElementsStore.bet_panel_hidden.value);

    function callAction(action: BetSelectActions) {
        getProp(props.action)?.(action);
    }

    return <$PanelDisplay
        name='bet_display'
        label='spinLabel'
        isBetHidden={betPanelHidden}
        value={props.betFormatted}
        maxWidth={280}
        {...props}
    >
        <$Sprite
            texture='win_background_sys_ui'
            anchor={0.5}
        />

        <$GraphicsBox
            responsiveBoxSize
            responsive={{
                box: {width: '300px', height: '106px'},
                translate: {x: '-50%', y: '-50%'},
            }}
            boxColor={0xff00ff}
            renderable={false}
            interactive={interactive}
            buttonMode
            events={{
                pointertap: () => uiMainScreenEmitter.emit('PRESSED_BET_SELECT')
            }}
        />

        <$Button
            name='minus_btn'
            hitArea={BUTTON_HIT_AREA}
            action={callAction.bind(null, 'decrease')}
            disabled={disableMinus}
            responsive={{box: {x: '-195px'}}}
        />
        <$Button
            name='plus_btn'
            hitArea={BUTTON_HIT_AREA}
            action={callAction.bind(null, 'increase')}
            disabled={disablePlus}
            responsive={{box: {x: '195px'}}}
        />
    </$PanelDisplay>;
};